import {Axios} from '../plugins/axios.js';


const state = {
  products : [],
}

const getters = {

}

const mutations =  {
  // filterProducts(state, payload) {
  //   console.log('filterProducts');
  //   state.products = payload;
  // }

}

const actions = {
  setDataLogin ({ commit, state }, payload) {
    return new Axios()
    .post(`auth/admin/login`,payload.data)
    .then(response => {
      return response;
    })
    .catch(()=>{
      return 'error';
    })
  },

  setDataAgentLogin ({ commit, state }, payload) {
    return new Axios()
    .post(`auth/agent/login`,payload.data)
    .then(response => {
      return response;
    })
    .catch(()=>{
      return 'error';
    })
  },




}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
